import React from "react";
import LegalLayout from "../../components/LegalLayout";

const sectionStyle = { marginBottom: 24 };
const h1Style = {
	fontSize: 28,
	fontWeight: 700,
	margin: "0 0 24px",
	color: "#0f172a",
};
const h2Style = {
	fontSize: 18,
	fontWeight: 600,
	margin: "20px 0 10px",
	color: "#334155",
};
const pStyle = { margin: "0 0 12px" };

export default function LegalPrivacidad() {
	return (
		<LegalLayout title="Política de Privacidad">
			<h1 style={h1Style}>Política de Privacidad</h1>

			<section style={sectionStyle}>
				<h2 style={h2Style}>Responsable del tratamiento</h2>
				<p style={pStyle}>
					<strong>Responsable:</strong> Yowlu SL (operando bajo la marca Viajes Molones)
				</p>
				<p style={pStyle}>
					<strong>Email:</strong> hola@viajesmolones.com
				</p>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>Datos que recopilamos</h2>
				<p style={pStyle}>Podemos recopilar:</p>
				<ul style={{ margin: "0 0 12px", paddingLeft: 24 }}>
					<li>Datos identificativos (nombre, email)</li>
					<li>Datos de acceso a la cuenta</li>
					<li>Información de compras realizadas</li>
					<li>Datos técnicos de navegación</li>
					<li>Preferencias dentro de la plataforma</li>
				</ul>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>Finalidad del tratamiento</h2>
				<p style={pStyle}>Los datos se utilizan para:</p>
				<ul style={{ margin: "0 0 12px", paddingLeft: 24 }}>
					<li>Crear y gestionar cuentas de usuario</li>
					<li>Permitir el acceso a contenidos digitales adquiridos</li>
					<li>Gestionar pagos y facturación</li>
					<li>Enviar comunicaciones relacionadas con el servicio</li>
					<li>Mejorar la experiencia de usuario</li>
				</ul>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>Base legal</h2>
				<ul style={{ margin: "0 0 12px", paddingLeft: 24 }}>
					<li>Ejecución de un contrato (compra de productos digitales)</li>
					<li>Consentimiento del usuario</li>
					<li>Cumplimiento de obligaciones legales</li>
				</ul>
				<p style={pStyle}>
					Cuando el tratamiento se base en el consentimiento, el usuario podrá
					retirarlo en cualquier momento sin que ello afecte a la licitud del
					tratamiento realizado previamente.
				</p>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>Encargados de tratamiento</h2>
				<p style={pStyle}>
					Se utilizan proveedores externos necesarios para el servicio:
				</p>
				<ul style={{ margin: "0 0 12px", paddingLeft: 24 }}>
					<li>Stripe (procesamiento de pagos)</li>
					<li>Servicios de hosting y almacenamiento</li>
					<li>Herramientas de analítica web (p. ej. Google Analytics, si aceptas cookies analíticas)</li>
				</ul>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>Transferencias internacionales</h2>
				<p style={pStyle}>
					Algunos de estos proveedores (como Stripe o Google) pueden tratar datos
					en países fuera del Espacio Económico Europeo (EEE). En esos casos se
					aplican garantías adecuadas reconocidas por el RGPD: cláusulas tipo
					aprobadas por la Comisión Europea, decisiones de adecuación o
					certificaciones equivalentes, para asegurar un nivel de protección
					adecuado.
				</p>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>Conservación</h2>
				<p style={pStyle}>
					Los datos se conservarán mientras exista relación contractual y,
					después, durante los plazos legalmente exigidos (p. ej. datos
					facturación y contables, obligaciones fiscales y mercantiles). Los
					datos de cuenta se mantendrán mientras la cuenta esté activa; tras
					baja o supresión, se conservarán el tiempo necesario para
					reclamaciones o obligaciones legales.
				</p>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>Derechos del usuario</h2>
				<p style={pStyle}>
					Puedes ejercer tus derechos de acceso, rectificación, supresión,
					oposición, limitación del tratamiento y portabilidad escribiendo a
					hola@viajesmolones.com. Responderemos en el plazo legal.
				</p>
				<p style={pStyle}>
					También tienes derecho a presentar una reclamación ante la Agencia
					Española de Protección de Datos (AEPD): www.aepd.es.
				</p>
			</section>

			<p style={{ ...pStyle, fontSize: 14, color: "#64748b" }}>
				Última actualización: 8 de marzo de 2026
			</p>
		</LegalLayout>
	);
}
